import React from 'react'
import { ProgramFeatureContentBarGraphItem } from './Item'

type Props = {
  entertainmentImpact: number
  learningImpact: number
}

export const ProgramFeatureContentBarGraph = ({
  entertainmentImpact,
  learningImpact,
}: Props): JSX.Element => (
  <div className="flex flex-col justify-around items-center lg:py-[1vw] lg:w-[25.3vw] h-[28.75vw] lg:h-[9.2vw] bg-white border border-[#E7E7E7]">
    <ProgramFeatureContentBarGraphItem
      text="エンタメ要素"
      value={entertainmentImpact}
    />
    <ProgramFeatureContentBarGraphItem
      text={`学び・\nスキルアップ`}
      value={learningImpact}
    />
  </div>
)
